type NetworkInfo = {
  saveData?: boolean;
  effectiveType?: string;
};

type NavigatorWithPerfHints = Navigator & {
  deviceMemory?: number;
  connection?: NetworkInfo;
};

export function isLowPowerEnvironment(): boolean {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return false;
  }

  const nav = navigator as NavigatorWithPerfHints;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const saveData = !!nav.connection?.saveData;
  const slowNetwork = ['slow-2g', '2g'].includes(nav.connection?.effectiveType ?? '');
  const lowCoreCount = (nav.hardwareConcurrency ?? 8) < 4;
  const lowMemory = (nav.deviceMemory ?? 8) < 4;

  return reducedMotion || saveData || slowNetwork || (lowCoreCount && lowMemory);
}
